module.exports = __webpack_public_path__ + "img/academy_pos_leadership.bf3c8068.png";